import {TextField} from "@mui/material";
import {t} from "i18next";
import {Field, useFormikContext} from "formik";

export interface ZipInputProps {
    fieldName: string;
    placeholder?: string;
}

const defaultZipPlaceholder = t("zip.placeholder") + `(${t("optional")})`

export default function ZipInputFormik({fieldName, placeholder = defaultZipPlaceholder}: ZipInputProps) {

    const formik = useFormikContext<any>()

    const onChangeValue = async (value: string) => {
        const zipCode = value.toUpperCase().replace(/[^0-9\-A-Z]+/g, '').slice(0, 10)
        await formik.setFieldValue(fieldName, zipCode)
    }

    return <Field
        name={fieldName}
        render={() => <TextField fullWidth maxRows={1} value={formik.values[fieldName]}
                                 onChange={(event) => onChangeValue(event.target.value)}
                                 placeholder={placeholder}
                                 onBlur={() => formik.setFieldTouched(fieldName, true)}
                                 error={!!formik.errors[fieldName] && !!formik.touched[fieldName]}
        />}
    />

}